module.exports = __webpack_public_path__ + "img/login_logo_top - 副本.cd2d4166.png";